import React, { FormEvent, useEffect, useState } from "react";
import usePortal from "../../contexts/PortalContext";
import Styles from "./SavePrompt.module.scss";

export interface SavePromptProps {
    shouldShow: boolean;
    text?: string;
    onReset?: () => void;
    onSave: (evt: FormEvent) => void;
}

const FEATURE_NEW_SAVE = "frontend.save.redesign";
export default function SavePrompt(props: SavePromptProps) {
    const { featureFlags } = usePortal();

    const [isResetClicked, setIsResetClicked] = useState<boolean>(false);

    useEffect(() => {
        setIsResetClicked(false);
    }, [props.onReset]);

    if (!props.shouldShow) {
        return null;
    }

    if (!featureFlags.has(FEATURE_NEW_SAVE)) {
        return (
            <div className="d-flex justify-content-end mt-3 fixed-bottom border-top p-3 bg-white">
                <button type="submit" className="btn btn-primary" onClick={props.onSave}>
                    Save
                </button>
            </div>
        );
    }

    const submit = (evt: FormEvent) => {
        const form = (evt.target as HTMLFormElement).closest("form");
        const isValid = !form || form?.reportValidity();
        if (isValid) {
            props.onSave?.(evt);
        }
    };

    return (
        <div className="fixed-bottom">
            {isResetClicked && (
                <div className={`bg-default px-3 py-2 rounded mx-auto d-flex `
                + `justify-content-between align-items-center text-light ${Styles["save-container"]}`}
                >
                    Are you sure you want to reset back to the original?
                    <button type="submit" className="btn btn-danger text-gray-300" onClick={props.onReset}>
                        Confirm
                    </button>
                </div>
            )}

            <div className={`bg-default px-3 py-2 rounded mx-auto d-flex `
                + `justify-content-between align-items-center ${Styles["save-container"]}`}
            >
                <div className="text-gray-200 text-nowrap flex-grow-1">
                    {props.text}
                </div>
                {props.onReset && (
                    <button
                        type="button"
                        className="btn btn-none btn-small text-light "
                        onClick={() => setIsResetClicked(true)}
                    >
                        Reset
                    </button>
                )}
                <button type="submit" className="btn btn-secondary text-gray-300" onClick={submit}>
                    Save
                </button>
            </div>
        </div>
    );
}

SavePrompt.defaultProps = {
    text: "Do you want to save changes?",
    onReset: undefined,
};
